import { createAction, props } from '@ngrx/store';
import { CountryInfo, PersistedAppContext } from './app-context.model';

export const setSelectedCountry = createAction(
  '[AppContext] Set Selected Country',
  props<{ selectedCountry: CountryInfo }>()
);

export const setAllCountries = createAction(
  '[AppContext] Set All Countries',
  props<{ allCountries: CountryInfo[] }>()
);

export const setOriginalUser = createAction(
  '[AppContext] Set Original User',
  props<{ originalUser: string }>()
);

export const setOriginalRole = createAction(
  '[AppContext] Set Original Role',
  props<{ originalRole: string }>()
);

export const setIsSuperAdmin = createAction(
  '[AppContext] Set Is Super Admin',
  props<{ isSuperAdmin: string }>()
);

export const setPersistedAppContext = createAction(
  '[AppContext] Set Persisted App Context',
  props<PersistedAppContext>()
);

export const hydrateAppContext = createAction(
  '[AppContext] Hydrate App Context',
  props<{ context: PersistedAppContext }>()
);

export const clearAppContext = createAction('[AppContext] Clear App Context');
